import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { panelS } from "../../common/styles/panelStyles";
import ReceptionPlacesShowForm from "../components/ReceptionPlacesShowForm";
import { toggleReceptionPlacesPanel } from "../../../config/redux/receptionPlaces/receptionPlacesActions";

const ReceptionPlacesPanel: React.FC = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const { receptionPlacesPanelOpen } = useSelector(
        (state: RootStateOrAny) => state.receptionPlaces
    );

    const dismissPanel = () => {
        dispatch(toggleReceptionPlacesPanel({ isOpen: false }));
    };

    return (
        <Panel
            isOpen={receptionPlacesPanelOpen}
            closeButtonAriaLabel={t("nav.close") as string}
            headerText={t("nav.panelPickupPointDetails") as string}
            onDismiss={dismissPanel}
            type={3}
            styles={panelS}
            isHiddenOnDismiss={true}
        >
            <ReceptionPlacesShowForm />
        </Panel>
    );
};

export default ReceptionPlacesPanel;